import { frontendURL } from '../../../helper/URLHelper';
import GoogleSheet from './Index.vue';
import GSheetKBDetails from './GSheetKBDetails.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/google_sheet'),
      name: 'google_sheet',
      component: GoogleSheet,
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    },
    {
          path: frontendURL('accounts/:accountId/google_sheet/:GSheetKBId'),
          name: 'google_sheet_details',
          component: GSheetKBDetails,
          meta: {
            permissions: ['administrator'],
          },
          beforeEnter: async (to, from, next) => {
            await subscriptionGuard(to, from, next, store);
          },
        }
  ],
};
